import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-org-l',
  templateUrl: './org-l.component.html',
  styleUrls: ['./org-l.component.scss']
})
export class OrgLComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
